import { Checkbox, Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { WorksheetGridFieldSection, WorksheetRecordGrid } from 'Components/Worksheets/Core';
import { prefixRecordFieldSetNames } from 'Components/Worksheets/Core/WorksheetRecordGrid/helpers';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';
import { getGridFieldSet as getMoistureContentGridFieldSetOvenDry } from 'Components/Worksheets/MoistureContentWorksheet/As/1289_2_1_1/gridFieldSets';
import { getGridFieldSet as getMoistureContentGridFieldSetHotplateDry } from 'Components/Worksheets/MoistureContentWorksheet/As/1289_2_1_6/gridFieldSets';
import { DryingEquipment } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { pipe } from 'Lib/Hooks/Selectors';
import deepEquals from 'Lib/Object/deepEquals';
import React from 'react';
import { useSelector } from 'react-redux';

let AsCompactionMoistureContentDeterminationGridSection: React.FC<IWorksheetComponent> = ({
  createWorksheetSelector,
}) => {
  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));
  const testPortionRecordProps = useSelector(
    pipe(createWorksheetSelector!('TestPortions'), (portions) =>
      (portions ?? []).map((p: any) => ({
        dim: p.ExcludedPoint,
      }))
    ),
    deepEquals
  );
  const dryingEquipment = useSelector(createWorksheetSelector!('Equipment.DryingEquipment')) as DryingEquipment;

  return (
    <WorksheetGridFieldSection name="TestPortions">
      <WorksheetRecordGrid
        name={'TestPortions'}
        orientation={'horizontal'}
        rowHeaderWidth={200}
        scrollLinkId="mddCompaction"
        recordProps={{
          width: 130,
          preventRemove: true, // Removed in another, related grid
          dim: (i) => testPortionRecordProps[i]?.dim,
          heading: 'number',
          headingLabel: 'Test Portion ID',
        }}
        fieldSet={[
          ...prefixRecordFieldSetNames(
            'MoistureDetermination',
            dryingEquipment === DryingEquipment.Hotplate
              ? getMoistureContentGridFieldSetHotplateDry(dryMassEntryOption)
              : getMoistureContentGridFieldSetOvenDry(dryMassEntryOption)
          ),
          {
            name: 'DryDensity',
            component: <Field input={<TextOutput />} />,
          },
          {
            name: 'ExcludedPoint',
            component: <Field input={<Checkbox />} />,
          },
        ]}
      />
    </WorksheetGridFieldSection>
  );
};

AsCompactionMoistureContentDeterminationGridSection = withInjectedProps(
  AsCompactionMoistureContentDeterminationGridSection
);

export { AsCompactionMoistureContentDeterminationGridSection };
export default AsCompactionMoistureContentDeterminationGridSection;
